import { useNetwork } from 'wagmi';

export const useExplorerUrl = () => {
  const { chain } = useNetwork();

  return chain?.blockExplorers?.default.url;
};
